import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import React from "react";
import {
  changeFormValidity,
  selectSearchFlightsForm,
} from "../searchFlightsSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useTranslation } from "react-i18next";
import {
  fetchDestinationsResults,
  fetchResults,
} from "../SearchFlightsActions";

const validateForm = (form, validationConfig?) => {
  const validity = {
    originAirport: true,
    destinationAirport: true,
    departingDateFilled: true,
    returningDateFilled: true,
    departingDateBeforeReturningDate: true,
    roundTripDateRangeRestriction: true,
    global: true,
  };
  if (form.originAirport === null) {
    validity.originAirport = false;
    validity.global = false;
  }
  if (form.destinationAirport === null && !form.destinationAnywhere) {
    validity.destinationAirport = false;
    validity.global = false;
  }
  if (form.departingDate === null) {
    validity.departingDateFilled = false;
    validity.global = false;
  }
  if (form.returningDate === null) {
    validity.returningDateFilled = false;
    validity.global = false;
  }
  if (
    form.departingDate !== null &&
    form.returningDate !== null &&
    form.roundTrip &&
    form.returningDate < form.departingDate
  ) {
    validity.departingDateBeforeReturningDate = false;
    validity.global = false;
  }
  if (
    validationConfig?.roundTripDateRangeRestriction?.enabled &&
    form.roundTrip &&
    form.departingDate !== null &&
    form.returningDate !== null &&
    validationConfig.roundTripDateRangeRestriction.splitDate
  ) {
    const splitTimestamp = new Date(
      validationConfig.roundTripDateRangeRestriction.splitDate
    ).getTime();
    if (
      form.departingDate < splitTimestamp &&
      form.returningDate >= splitTimestamp
    ) {
      validity.roundTripDateRangeRestriction = false;
      validity.global = false;
    }
  }
  return validity;
};

function SearchFlightsButton() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const loading = useAppSelector(
    (state) => state.searchFlights.results.loading
  );
  const form = useAppSelector(selectSearchFlightsForm);
  const validationConfig = useAppSelector(
    (state) => state.config.components.Validation
  );

  const searchFlights = async (form) => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
    const validity = validateForm(form, validationConfig);
    dispatch(changeFormValidity(validity));
    if (validity.global) {
      if (form.destinationAnywhere) {
        dispatch(fetchDestinationsResults());
      } else {
        dispatch(fetchResults({ queryTrigger: "form_submission" }));
      }
    }
  };

  return (
    <button
      id="search-button"
      disabled={loading}
      className={`button is-primary ${loading ? " is-loading" : ""}`}
      onClick={() => {
        if (!loading) {
          searchFlights(form);
        }
      }}
    >
      <span className="icon">
        <FontAwesomeIcon icon={faSearch} />
      </span>
      <span>{t("BUTTON_SEARCH")}</span>
    </button>
  );
}

export default SearchFlightsButton;
